import React from 'react';
import { ChatManager } from '@rebelnerds/chat-saas-client';
import { isMobile } from 'react-device-detect';
import { Message } from '@material-ui/icons';

import LiveBroadcastStore from '../../store/LiveBroadcastStore';
import GroupShowStore from '../../store/GroupShowStore';
import { isSubscribedToGroupShowAnchor, isSubscribedToGroupShowAnchorByUsername } from '../../utils/helpers';

import BroadcastChatMessage from './BroadcastChatMessage/BroadcastChatMessage';
import BroadcastChatHeader from './BroadcastChatHeader/BroadcastChatHeader';
import BroadcastChatInput from './BroadcastChatInput/BroadcastChatInput';


import './css/BroadcastChat.css';
import './css/BroadcastChat.mobile.css';


const GROUP_SHOW_PARTICIPANT_STOPPED = 'GROUP_SHOW_PARTICIPANT_STOPPED';
const GROUP_SHOW_PARTICIPANT_JOINED = 'GROUP_SHOW_PARTICIPANT_JOINED';

class BroadcastChat extends React.PureComponent {

  username = null;
  anchorUsername = null;
  activeChatSession = null;

  chatConversationWrapperRef = React.createRef();

  state = {
    chatOnline: false,
    inputMessage: '',
    roomState: {},
    roomMessages: [],
    subscribed: false,
    landscapeChatVisibility: true,
    isSpotlight: false,
    spotlightedByAnchorNickname: null,
    spotlightedByAnchorUsername: null,
  };

  componentWillUnmount() {
    document.removeEventListener('myCustomEvent', this.handleEv);
  }

  handleEv = (e) => {
    const { changeNsfwFlag } = this.props;
    changeNsfwFlag(e.detail.nsfw);
  };

  onEmoticonPicked = (emoticon) => {
    this.setState((state) => {
      return { inputMessage: `${state.inputMessage}${emoticon.native}` };
    });
  };

  componentDidMount() {

    document.addEventListener('myCustomEvent', this.handleEv, false);

    const { user, isBroadcaster, anchor, broadcasting, guestUser, isSpotlighing } = this.props;
    this.username = user.user ? user.user.username.toLowerCase() : guestUser;
    this.anchorUsername = isBroadcaster ? this.username : anchor.username;
    if (broadcasting || isSpotlighing) {
      if (this.props.isTulumRealityShow) {
        this.startTulumChat();
      } else {
        this.startChat(this.props.streamingSourceType);
      }
    }

  }

  componentWillReceiveProps(newProps) {
    if (this.props.broadcasting !== newProps.broadcasting) {
      if (newProps.broadcasting === true) {
        if (newProps.streamingSourceType !== this.props.streamingSourceType) {
          this.startChat(newProps.streamingSourceType);
        } else {
          this.startChat(this.props.streamingSourceType);
        }

      } else {
        this.stopChat();
      }
    }
    if (this.props.nsfw !== newProps.nsfw) {
      this.activeChatSession && this.activeChatSession.updateRoom(false, { nsfw: newProps.nsfw });
      LiveBroadcastStore.updateSfwStreamFlag(newProps.nsfw);
    }
  }

  startTulumChat = () => {
    const { chatService } = this.props;

    ChatManager.init(chatService.chatServiceUrl, 'tempted');
    ChatManager.createSession(chatService.username, chatService.roomName, chatService.token, this.chatSessionHandler);
  };

  startChat = (streamingSourceType) => {
    const { chatService, chatServiceTempted, guestUser, isSpotlighing, spotlighedAnchorUsername } = this.props;
    const anchorUsername = isSpotlighing ? spotlighedAnchorUsername : this.anchorUsername;
    if (streamingSourceType === 'TEMPTED') {
      if (chatServiceTempted) {
        if (chatServiceTempted[0] && chatServiceTempted[0].custom && chatServiceTempted[0].custom.roomName) {
          // a group show has a custom room name
          ChatManager.createSession(guestUser, chatServiceTempted[0].custom.roomName, chatServiceTempted[0].token, this.chatSessionHandler);
        } else {
          ChatManager.init(chatServiceTempted.url, 'tempted');
          ChatManager.createSession(guestUser, anchorUsername, chatServiceTempted.token, this.chatSessionHandler);
        }
      } else {
        ChatManager.init(chatService.url, 'nakednews');
        ChatManager.createSession(guestUser, anchorUsername, this.props.chatService.token, this.chatSessionHandler);
      }
    } else {
      ChatManager.init(chatService.url, 'nakednews');
      ChatManager.createSession(guestUser, this.anchorUsername, this.props.chatService.token, this.chatSessionHandler);
    }
  };

  stopChat = () => {
    if (this.activeChatSession) {
      this.activeChatSession.closeRoom();
    }
  };

  chatSessionHandler = (chatSession, error) => {
    const { isBroadcaster } = this.props;
    if (error) {
      console.error(error);
    } else {
      this.activeChatSession = chatSession;
      if (isBroadcaster) {
        this.activeChatSession.createAndJoinRoom('custom status', {}, this.joinRoomHandler);
      } else {
        this.activeChatSession.joinRoom(this.joinRoomHandler);
      }
    }
  };

  joinRoomHandler = (error) => {
    if (error) {
      console.error(error);
    } else {
      this.activeChatSession.setRoomStateListener(this.roomStateListener);
      this.activeChatSession.setRoomMessagesListener(this.roomMessagesListener);
      this.activeChatSession.setRoomUsersCountListener(this.props.roomUsersCountListener);
      // TODO
      // this.activeChatSession.setRoomRosterListener(roomRosterListener);
    }
  };

  roomStateListener = (roomStateEvent) => {
    const {
      changeNsfwFlag,
      guestUser,
      user,
      anchorId,
      isSpotlighing,
    } = this.props;
    const { isInGroupShow } = GroupShowStore;

    let chatOnline = (roomStateEvent.type === 'ROOM_STATE_UPDATE');
    const customEvent = roomStateEvent.data ? roomStateEvent.data.custom : null;
    const isSpotlight = customEvent?.isSpotlight;
    const spotlightedByAnchorNickname = customEvent?.isSpotlightByTemptationNickname;
    const broadcastingTemptationUsername = customEvent?.broadcastingTemptationUsername;
    const isSpotlightByTemptationUsername = customEvent?.isSpotlightByTemptationUsername;
    LiveBroadcastStore.setIsSpotlight(isSpotlight);
    LiveBroadcastStore.setSpotlightedByAnchorNickname(spotlightedByAnchorNickname);
    if (roomStateEvent.type === 'ROOM_CLOSED') {
      this.props.onBroadcasterClosedSession && this.props.onBroadcasterClosedSession();
      this.activeChatSession.leaveRoom();
      if (isInGroupShow) {
        GroupShowStore.resetRemainingGroupShowData();
      }
    }

    if (isSpotlighing && customEvent?.isSpotlight === false) {
      this.props.onSpotlighterClosedSession && this.props.onSpotlighterClosedSession();
      chatOnline = false;
      this.activeChatSession.leaveRoom();
    }

    if (isInGroupShow && customEvent && customEvent.performers) {
      GroupShowStore.receivedGroupShowEvent(customEvent);
    }
    let subscribedToOneOfTheAnchors = false;
    if (customEvent?.isSpotlight) {
      subscribedToOneOfTheAnchors = isSubscribedToGroupShowAnchorByUsername(user, broadcastingTemptationUsername) || isSubscribedToGroupShowAnchorByUsername(user, isSpotlightByTemptationUsername);
    }

    LiveBroadcastStore.setSubscribedToOneOfTheAnchors(subscribedToOneOfTheAnchors);

    const subscribed =
      user.user && user.user.account.anchorSubscriptions ? user.user.account.anchorSubscriptions.filter((anchor) => anchor.subCategory === anchorId).length > 0 : false;

    const isGuest = guestUser && guestUser?.includes('guest');
    const isNotSubscribed = !subscribed && !subscribedToOneOfTheAnchors;
    const shouldChangeNsfwFlag = isGuest || isNotSubscribed;

    if (customEvent && shouldChangeNsfwFlag && changeNsfwFlag) {
      changeNsfwFlag(customEvent.nsfw);
    }
    this.props.setSpotlightedByTemptationName(isSpotlightByTemptationUsername)
    this.setState({ roomState: roomStateEvent, chatOnline, subscribed, isSpotlight, spotlightedByAnchorNickname, spotlightedByAnchorUsername: isSpotlightByTemptationUsername });
  };

  roomMessagesListener = (roomMessage) => {
    if (roomMessage.type === 'CUSTOM' && roomMessage.attributes.type === 'groupShowEvent') {
      GroupShowStore.moveToGroupShow();
    }

    if (!(roomMessage.message === GROUP_SHOW_PARTICIPANT_STOPPED || roomMessage.message === GROUP_SHOW_PARTICIPANT_JOINED)) {
      this.setState((prevState) => {
        return { roomMessages: [...prevState.roomMessages, roomMessage] };
      }, () => {
        if (this.state.roomState.type !== 'ROOM_CLOSED' && this.state.chatOnline) {
          this.scrollToBottom();
        }
      });
    }
  };

  displayMessages = () => {
    const { isInGroupShow } = this.props;
    const { isSpotlight } = this.state;

    return this.state.roomMessages.map((messageObj, index) => {
      const nickname = messageObj.attributes ? messageObj.attributes.nickname : null;

      return (
        <BroadcastChatMessage
          key={`${messageObj.username}-${index}`}
          attributes={messageObj.attributes}
          isInGroupShow={isInGroupShow}
          isSpotlight={isSpotlight}
          message={messageObj.message}
          nickname={nickname}
          source={messageObj.attributes && messageObj.attributes.smSource}
          user={this.props.user}
          username={messageObj.username}
        />
      );
    });
  };

  isValidInput = (inputMessage) => {
    const regex = /^[\r\n]+$/;
    const hasOnlyNewlines = regex.test(inputMessage);

    return !hasOnlyNewlines;
  };

  onMessageSend = () => {
    const { inputMessage, subscribed } = this.state;
    const { guestUser, isBroadcaster, openContextualOverlay, user, anchorId, isInGroupShow } = this.props;
    const { subscribedToOneOfTheAnchors } = LiveBroadcastStore;
    const isAnchor = user && user.user ? user.user.account.anchor : false;
    const { groupShowParticipant: { anchorDetails } } = GroupShowStore;

    // Group shows - fan should be able to send a message if he is subscribed to at least one party show participant (anchor)
    let isSubscribedToGroupShowHost = false;
    let isSubscribedToGroupShowParticipant = false;

    if (isInGroupShow) {
      isSubscribedToGroupShowHost = isSubscribedToGroupShowAnchor(user, anchorId);
      isSubscribedToGroupShowParticipant = isSubscribedToGroupShowAnchor(user, anchorDetails.id);
    }

    const isSubscribedToOneGroupShowAnchor = isSubscribedToGroupShowHost || isSubscribedToGroupShowParticipant || subscribedToOneOfTheAnchors;
    // ___remove isBroadcaster part when disabling chat for anchor
    if (!isBroadcaster && (guestUser.includes('guest') || !subscribed) && !isAnchor && !isSubscribedToOneGroupShowAnchor) {
      // Only fans can send messages and other anchors; guest users and active users that are not subcribed to particular anchor are not allowed
      openContextualOverlay(true);

      return;
    }

    if (inputMessage.length > 0 && this.isValidInput(inputMessage)) {
      this.activeChatSession.writeMessage(inputMessage);
    }
    this.setState({ inputMessage: ''});
  };

  updateInputMessage = (e) => {
    this.setState({ inputMessage: e.target.value });
  };

  onInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.onMessageSend();
    }
  };

  scrollToBottom = () => {
    this.chatConversationWrapperRef.current.scrollTop = this.chatConversationWrapperRef.current.scrollHeight;
  };

  toggleChatLandscapeVisibility = () => {
    this.setState({ landscapeChatVisibility: !this.state.landscapeChatVisibility });
  };

  shouldShowTipButtonForGroupShow = () => {
    const {
      streamData,
      groupShowParticipant: {
        participantStreamData,
        anchorDetails,
      },
    } = GroupShowStore;
    const { user, anchorId } = this.props;
    let isSubscribedToGroupShowHost = isSubscribedToGroupShowAnchor(user, anchorId);
    let isSubscribedToGroupShowParticipant = isSubscribedToGroupShowAnchor(user, anchorDetails.id);

    if ((isSubscribedToGroupShowHost || isSubscribedToGroupShowParticipant) && (streamData || participantStreamData)) {
      return true;
    }

    return false;
  }

  getSecondAnchorToTip = () => {
    const secondAnchorData = {};
    const { isSpotlighing, isSpotlight, spotlighedAnchorNickname, anchor, spotlighedAnchorUsername} = this.props;
    const { spotlightedByAnchorNickname } = this.state;
    const { groupShowParticipant: { anchorDetails, participantStreamData, participantUsername }, isInGroupShow } = GroupShowStore;
    if (isInGroupShow && participantStreamData) {
      secondAnchorData.username = participantUsername;
      secondAnchorData.nickname = anchorDetails.nickname
    }

    if (isSpotlight && !isSpotlighing && spotlightedByAnchorNickname !== anchor.username) {
      secondAnchorData.nickname = spotlightedByAnchorNickname;
      secondAnchorData.username = this.state.spotlightedByAnchorUsername;
    } else if (isSpotlighing && !isSpotlight) {
      secondAnchorData.nickname = spotlighedAnchorNickname;
      secondAnchorData.username = spotlighedAnchorUsername;
    }

    return secondAnchorData;
  };

  render() {
    const {
      isBroadcaster,
      roomCount,
      enableToggleInLandscape,
      anchor,
      anchorId,
      user,
      isBanned,
      isSpotlighing,
      spotlighedAnchorNickname,
      isTulumRealityShow,
      isInGroupShow,
    } = this.props;

    let anchorData;
    if (isBroadcaster) {
      anchorData = {
        id: user.user.account.anchor.id,
        name: user.user.username,
      };
    } else {
      anchorData = {
        id: anchorId,
        name: anchor.name,
        username: anchor.username,
      };
    }
    const { chatOnline, inputMessage, landscapeChatVisibility, spotlightedByAnchorNickname, isSpotlight } = this.state;

    let landscapeToggleButtonClassName = 'mobile-landscape-toggle-broadcaster-chat';
    let innerChatContainerClassName = 'broadcast-chat';
    if (enableToggleInLandscape) {
      innerChatContainerClassName += ' broadcast-chat--with-landscape-toggle-enabled';
    }
    if (!landscapeChatVisibility) {
      landscapeToggleButtonClassName += ' mobile-landscape-toggle-broadcaster-chat--chat-hidden';
      innerChatContainerClassName += ' broadcast-chat--landscape-chat-hidden';
    }
    const secondAnchorToTip = this.getSecondAnchorToTip();

    return (
      <div className="broadcast-chat-container">
        {isMobile && chatOnline && enableToggleInLandscape && (
          <button
            className={landscapeToggleButtonClassName}
            type="button"
            onClick={this.toggleChatLandscapeVisibility}
          >
            <Message fontSize="inherit" />
          </button>
        )}
        <div className={innerChatContainerClassName}>
          {chatOnline ? (
            <>
              <BroadcastChatHeader
                anchor={anchorData}
                isAnchor={!!user?.user?.account?.anchor}
                isAuthentified={this.props.user.authenticated}
                isBanned={isBanned}
                isInGroupShow={isInGroupShow}
                isTulumRealityShow={isTulumRealityShow} roomCount={roomCount}
                secondAnchorToTip={secondAnchorToTip}
                showTipBtnForGroupShow={this.shouldShowTipButtonForGroupShow()}
              />

              {
                isSpotlighing && (
                  <div className="spotlight-chat-notification">
                    {anchor.name} is spotlighting {spotlighedAnchorNickname}
                  </div>
                )
              }
              {
                isSpotlight && spotlightedByAnchorNickname !== anchor.username && !isSpotlighing && (
                  <div className="spotlight-chat-notification">
                    {spotlightedByAnchorNickname} is spotlighting {anchor.name}
                  </div>
                )
              }
              <div
                ref={this.chatConversationWrapperRef}
                className={`broadcast-chat-conversation-wrapper ${(isSpotlighing || isSpotlight) ? 'broadcast-chat-padding-top' : ''}`}
                style={isBroadcaster && {/* ___uncomment when disabling anchor messaging height: '100%'*/ }}
              >
                <div className="broadcast-chat-conversation">
                  {this.displayMessages()}
                </div>
              </div>
              {user.authenticated &&
                <BroadcastChatInput
                  inputMessage={inputMessage}
                  updateInputMessage={this.updateInputMessage}
                  onEmoticonPicked={this.onEmoticonPicked}
                  onInputKeyPress={this.onInputKeyPress}
                  onMessageSend={this.onMessageSend}
                />
              }
            </>
          ) : (
            <>
              {!isMobile && (
                <div className="broadcast-chat-offline">
                  <p>Chat is offline</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default BroadcastChat;
